export const projectsEndpointIds = {
    GET_PROJECT_ADMIN: 'GET_PROJECT_ADMIN',
    SEARCH_PROJECTS: 'SEARCH_PROJECTS',
    UPDATE_PROJECT_ADMIN: 'UPDATE_PROJECT_ADMIN',
};
